module.exports = __webpack_public_path__ + "img/4.89a2da69.png";